import { Center, Spinner, VStack, Text, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSetTeamsConfig } from '@services/query-services/tenants.query-service';
import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';

export default function TeamsCallbackPage() {
  const { mutate: setTeamsConfig, isLoading, isError } = useSetTeamsConfig({ retry: 1 });
  const [searchParams] = useSearchParams();
  const user = useUserStore((state) => state.user);
  const navigate = useNavigate();
  const toast = useStyledToast();

  useEffect(() => {
    if (user) {
      if (user?.isGuest) {
        navigate('/');
        return;
      }
      const adminConsented = searchParams.get('admin_consent') === 'True';
      const microsoftTenantId = searchParams.get('tenant');
      const tenantId = user.tenants[0]?.id;
      if (adminConsented && tenantId) {
        setTeamsConfig(
          {
            body: { access_token: microsoftTenantId, alert_channel: 'fora-alerts' },
            params: { subscribe: true }
          },
          {
            onSuccess: () => {
              toast({
                title: 'Microsoft Teams Connected Successfully.',
                status: 'success'
              });

              if (user.coming_from === 'onboard') {
                setTimeout(() => {
                  window.close();
                }, 100);
              }

              navigate('/');
            }
          }
        );
      }
    }
  }, [user]);

  return (
    <Box data-cy='teams-callback-page'>
      <Center pt={10}>
        {isLoading && (
          <VStack gap={6}>
            <Text fontSize='lg'>Connecting to Teams...</Text>
            <Spinner size='xl' />
          </VStack>
        )}
        {isError && <Text fontSize='lg'>Failed to Connect Fora to Microsoft Teams</Text>}
      </Center>
    </Box>
  );
}
